export class MoreInfoLinkFactory {
    static create(moreInfoLink: ICatalogMoreInfoLink): IContentAPIMoreInfoLink {
        return new MoreInfoLink(moreInfoLink).serialize();
    }
}

export class MoreInfoLink {
    protected _type: MoreInfoLinkType;
    protected _uri: string | undefined;

    constructor(moreInfoLinks: ICatalogMoreInfoLink) {
        this._uri = moreInfoLinks.uri;
        this._type = moreInfoLinks.type ?? "general";
    }

    serialize(): IContentAPIMoreInfoLink {
        const moreInfoLinks: IContentAPIMoreInfoLink = {
            uri: this._uri,
            type: this._type
        };

        return moreInfoLinks;
    }
}

export interface IContentAPIMoreInfoLink {
    uri: string | undefined;
    type: MoreInfoLinkType;
}
